import { Component, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { NgbAccordionDirective } from '@ng-bootstrap/ng-bootstrap';
import { ContentType } from '../../../common/models/site.model';
import { CategoryWithGroups } from '../../../common/models/category-group.model';
import { Endpoint } from '../../../common/models/endpoint-group.model';
import { DocsNavItem, DocsNavChild } from '../../../common/models/nav.model';


@Component({
    selector: 'app-nav-items',
    templateUrl: './nav-items.component.html',
    styleUrls: ['./nav-items.component.scss', '../common/side-nav-common.component.scss'],
    standalone: false
})
export class NavItemsComponent implements OnChanges {
    @ViewChild('navAccordion', { static: false }) navAccordion: NgbAccordionDirective;

    // Inputs
    @Input() contentType: ContentType = 'api';
    @Input() groupedNavItems: CategoryWithGroups[] = [];
    @Input() docsNavItems: DocsNavItem[] = [];
    @Input() activeItem: string = '';
    @Input() activeGroup: string = '';
    @Input() activeCategoryId: string = '';
    
    // Outputs
    @Output() groupExpanded = new EventEmitter<void>();

    // Internal state
    groupSeenKeys = new Set<string>();
    renderedKeys: Set<string> = new Set();

    ngOnChanges(changes: SimpleChanges): void {
        // Reset seen keys when data changes
        if (changes['groupedNavItems'] || changes['docsNavItems']) {
            this.groupSeenKeys.clear();
            this.renderedKeys.clear();
        }
    }

    // ===== API Navigation Methods =====

    isCategoryExpanded(categoryId: string): boolean {
        return categoryId === this.activeCategoryId && this.contentType === 'api';
    }

    isGroupExpanded(groupCode: string): boolean {
        return groupCode === this.activeGroup && this.contentType === 'api';
    }

    trackByCategory(index: number, item: CategoryWithGroups): string {
        return item.categoryId;
    }

    trackByGroup(index: number, item: any): string {
        return item.groupCode;
    }

    trackByEndpoint(index: number, item: Endpoint & { debugKey: string }): string {
        return item.debugKey;
    }

    onGroupExpand(): void {
        this.groupSeenKeys.clear();
        this.renderedKeys.clear();
        this.groupExpanded.emit();
    }

    // ===== Docs Navigation Methods =====

    isDocCategoryExpanded(categorySlug: string | null): boolean {
        return categorySlug === this.activeGroup && this.contentType === 'docs';
    }

    isDocActive(pageSlug: string): boolean {
        return pageSlug === this.activeItem && this.contentType === 'docs';
    }

    trackByDocItem(index: number, item: DocsNavItem): number {
        return item.id;
    }

    trackByDocChild(index: number, item: DocsNavChild): number {
        return item.id;
    }

    // ===== Accordion Control =====

    collapseAll(): void {
        if (this.navAccordion) {
            this.navAccordion.collapseAll();
        }
    }
}